export const PREFIX = 'MD-ELECTION-TIER_';

export const SEARCH_REFRESH = PREFIX + 'SEARCH_REFRESH';

export const GET_ALL_DATA_BY_TENANT_ID_SUCCESS =
  PREFIX + 'GET_ALL_DATA_BY_TENANT_ID_SUCCESS';

export const GET_ALL_ELECTION_TIERS = PREFIX + 'GET_ALL_ELECTION_TIERS';
